<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-30 14:18:59
 * @FilePath: \gcp-fe\src\app\shop\components\platformIntroduction.vue
 * @Description: 平台简介
-->
<template>
  <div class="contactUs">
    <div class="contentMain">
      <base-bread-crumb
        class="bread-crumb"
        :currBreadCrumb="currBreadCrumb"
        :isShowPortal="true"
      ></base-bread-crumb>
    </div>
    <div class="mainBox">
      <div class="contentMain">
        <div class="title">平台简介</div>
        <p>
          中交招采网是为落实中交集团产业链、供应链协同发展构建的统一交易共享平台，致力于服务中交集团各级企业、项目与合作伙伴协同的服务平台，打造合作共赢的生态圈。
        </p>
        <p>
          平台涵盖了物资、设备、工程、服务等多种品类，招标、竞谈、询比、竞价等多种采购方式，为交易双方提供“多元化”、“一站式”服务。平台下设供应链金融、中交物流专区、资源共享专区、中交云仓专区、海外专区等多个专区，为交易双方提供数字化服务，促进供应链上下游企业深度融合、协同发展。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BaseBreadCrumb from "../../noticesList/components/baseBreadCrumb";
export default {
  name: "platformIntroduction",
  components: {
    BaseBreadCrumb
  },
  data() {
    return {
      currBreadCrumb: [
        {
          title: "平台简介"
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.ccui-app-mains {
  height: auto !important;
}
.contactUs {
  width: 100%;
  background: #eaeaea;

  .contentMain {
    width: 1180px;
    margin: 0 auto;
  }

  .mainBox {
    width: 100%;
    background: #fff;
    padding-bottom: 20px;

    .title {
      width: 100%;
      padding: 20px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #4a4a4a;
      border-bottom: 1px solid #eaeaea;
      margin-bottom: 20px;
    }
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #4a4a4a;
      text-indent: 2em; /* 首行缩进2个字符宽度 */
      padding-bottom: 20px;
    }
  }
}

.bread-crumb {
  padding: 10px 0;
  margin: 0 !important;
}
</style>
